import React from "react";
import { NO_DATA_AVAILABLE } from "../../utils/constants/index";

const error = (props) => {
  return (
    <div className="col">
      {props.error === null ? (
        <div className="text-center">{NO_DATA_AVAILABLE}</div>
      ) : (
        <div className="text-center">
          {props.error && props.error.errors && Array.isArray(props.error.errors) ? (
            <>
              <div>{props.error.errors[0].reason}</div>
              <>Error code : {props.error.errors[0].code}</>
            </>
          ) : props.error && props.error.status && props.error.error ? (
            <>
              <div>{props.error.error}</div>
              <> Error code : {props.error.status} </>
            </>
          ) : props.error && props.error.apierror ? (
            <>
              <div>{props.error.apierror.status}</div>
              <> {props.error.apierror.message} </>
            </>
          ) : <div>Something went wrong. Please try again later</div>}
        </div>
      )}
    </div>
  );
};

export default error;
